
<template>
  <div v-bind:id="'panels' + getId()" class="container-fluid m-0 p-0" style="height:100%">
    <div class="panelcontainer" style="position:relative;overflow:hidden;width:100%;height:100%;">
      <div class="row m-0 p-0" style="position:relative;overflow:hidden;width:100%;height:100%">
        <div class="panel-item p-0 m-0" v-bind:class="{'expanded': showright == false && showrightest == false , 'minimize': showright == true || showrightest == true}" id="mainpanel" ref="mainpanel" style="float: left; position: relative;">
          <slot name="main" scope="testScope"></slot>
          <div v-if="displayOverlay == true" id="paneloverlay"></div>
        </div>
        <div class="p-0 m-0 panel-item" style="position: absolute; display: none; height: 100%; z-index: 1001; padding-left:3px !important; right:0px;"  id="rightpanelcontainer">
          <div class="panel-item" id="rightpanel" v-bind:class="{'expanded': showright == true}" ref="rightpanel" style="position:absolute;z-index: 1001;">
            <slot name="right" scope="testScope"></slot>
          </div>
        </div>
        <div class="p-0 m-0 panel-item" style="position: absolute; display: none; height: 100%; z-index: 1001; right: 0px; padding-left:3px !important;" id="rightestpanelcontainer">
          <div class="panel-item" id="rightestpanel" v-bind:class="{'expanded': showrightest == true}" ref="rightestpanel" style="position:absolute;z-index: 1001;">
            <slot name="rightest" scope="testScope"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';

  export default {
    name: 'panels',
    components: {
      TimelineLite,
      gsap,
    },
    props: {
      showright: {
        type: Boolean,
        default: false
      },
      showrightest: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        showing: false,
        showingRightest: false,
        displayOverlay: false
      };
    },
    methods: {
      getId() {
        return "container_" + this._uid;
      },
      getWidth() {
        if (isExpanded())
          return "width:75%";
        return "";
      },
      startOverlay() {
        this.displayOverlay = true;
        this.$forceUpdate();
        //$('#paneloverlay').show();
      },
      endOverlay() {
        //$('#paneloverlay').hide();
        this.displayOverlay = false;
        this.$forceUpdate();
      },
      isExpanded() {
        return this.showing;
      },
      showRightest(timeout = 2) {
        this.showingRightest = true;
        var containerName = '#panels' + this.getId();
        $(containerName).find('#rightestpanelcontainer').show();
        $(containerName).find('#rightestpanel').addClass("expanded");
        this.startOverlay();
        this.calculateSizes();
      },
      showRight(timeout = 2) {
        this.showing = true;
        var containerName = '#panels' + this.getId();
        $(containerName).find('#rightpanelcontainer').show();
        $(containerName).find('#rightpanel').addClass("expanded");
        $(containerName).find('#mainpanel').addClass("minimize");
        $(containerName).find('#mainpanel').removeClass("expanded");
        this.startOverlay();
        this.calculateSizes();
      },
      hideRight(timeout = 2) {
        var thisContext = this;
        this.showing = false;
        var containerName = '#panels' + this.getId();
        $(containerName).find('#rightpanel').removeClass("expanded");
        $(containerName).find('#mainpanel').addClass("expanded");
        $(containerName).find('#mainpanel').removeClass("minimize");
        
        this.endOverlay();

        setTimeout(function () {
          $(containerName).find('#rightpanelcontainer').hide();
        }, 300)
        this.calculateSizes();
      },
      hideRightest(timeout = 2) {
        var thisContext = this;
        this.showingRightest = false;
        var containerName = '#panels' + this.getId();
        $(containerName).find('#rightestpanel').removeClass("expanded");
        this.endOverlay();
        //setTimeout(function () {
          $(containerName).find('#rightestpanelcontainer').hide();
        //}, 300)
        this.calculateSizes();
      },

      calculateSizes() {
        var containerName = '#panels' + this.getId();

        var width = 0;
        var right = "0px"

        if (this.showing == true) {
          $(containerName).find('#rightpanelcontainer').show();
          width = $(containerName).find('#rightpanelcontainer').width()
        }

        if (this.showingRightest == true) {
          $(containerName).find('#rightestpanelcontainer').show();
          var rightestWidth = $(containerName).find('#rightestpanelcontainer').width();
          width += rightestWidth;
          right = rightestWidth + "px";
        }
        $(containerName).find('#rightpanelcontainer').css('right', right);
        
        var parentWidth = $(containerName).width();
        $(containerName).find('#mainpanel').width(parentWidth - width);
      }
    },
    created() {
      
    },
    mounted() {

      if (this.showright == true) {
        this.showing = true;
      }

      if (this.showrightest == true) {
        this.showingRightest = true;
      }

      this.calculateSizes();

      window.onresize = this.calculateSizes;
      var containerName = '#panels' + this.getId();
      $(containerName).find("#rightpanelcontainer").resizable({ handles: 'w' });
      $(containerName).find("#rightestpanelcontainer").resizable({ handles: 'w' });

      var thisContext = this;
      $(containerName).find("#rightpanelcontainer").resize(function () {
        thisContext.calculateSizes();
      });
      $(containerName).find("#rightestpanelcontainer").resize(function () {
        thisContext.calculateSizes();
      });

      $('#paneloverlay').click(this.hideRight);
      
    },

    computed: {

    }
}
</script>
<style scoped>

  .panel-item {
    margin: auto;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 80px);
  }

  #mainpanel{
      height:100%;
  }

  #mainpanel.minimize {
    /*width: 66.66%;*/
    transition: width 0.4s ease;
  }

  #mainpanel.expanded {
    width: 100%;
    transition: width 0.4s ease;
  }



  @media (max-width: 768px) {
    #mainpanel {
      height: 100vh;
    }

    .panel-item {
      height: calc(100vh - 10px);
    }

    #mainpanel.expanded {
      transition: none;
      width: 100%;
    }

    #mainpanel.minimize {
      transition: none;
      width: 100%;
    }
  }

</style>

<style>

  #rightpanelcontainer{
      width:33%;
      overflow-x:visible;
  }

  #rightestpanelcontainer {
    width: 33%;
  }

  #rightpanel, #rightestpanel {
    height: 100%;
    width: 100%;
    overflow-x:visible;
    /*transition: right 1.2s ease-out !important;*/
  }

  #rightpanel.expanded, #rightestpanel.expanded {
    /*transition: right 1.2s ease-out !important;*/
    animation: fadeInRightCustom 0.7s ease-out;
  }

  #paneloverlay {
    display: none; /* Hidden by default */
  }

  @keyframes fadeInRightCustom {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }

  @media (max-width: 768px) {
    #rightpanelcontainer, #rightestpanelcontainer {
      width: 100%;
    }

    #rightpanel, #rightestpanel {
      width: 100% !important;
      height: calc(100% - 30px);
    }

  #paneloverlay {
    position: fixed; /* Sit on top of the page content */
    display: block; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  }
  }

</style>



// WEBPACK FOOTER //
// src/components/containers/panels.vue